import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';
import { estudiantesApi } from '../../control_estudios/estudiantes/EstudiantesService';

export const NOTAS_BLOPED_API = 'notas_bloped';
export const notasBlopedApi = `${baseUrl}/${NOTAS_BLOPED_API}`;

export const allNotasBlopedService = async (params) => {
  const res = await axios.get(notasBlopedApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const allEstudiantesNotasBlopedService = async (params) => {
  const res = await axios.get(`${notasBlopedApi}/estudiantes`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveNotasBlopedService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${notasBlopedApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(notasBlopedApi, data, { headers: token({}) });
  }
  return res;
};

export const oneNotasBlopedService = async (id) => {
  const res = await axios.get(notasBlopedApi, { headers: token({}) });
  return res;
};

export const deleteNotasBlopedService = async (id) => {
  const res = await axios.delete(notasBlopedApi, { headers: token({}) });
  return res;
};

export const allEstudiantesPlanNotasBlopedService = async (params) => {
  const res = await axios.get(`${estudiantesApi}/bloques-pedagogicos`, {
    headers: token({}),
    params,
  });
  return res;
};
